import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import {filter, pairwise} from 'rxjs/operators';
import { _ } from 'underscore';

@Component({
  selector: 'app-support-and-learn',
  templateUrl: './support-and-learn.component.html',
  styleUrls: ['./support-and-learn.component.css']
})
export class SupportAndLearnComponent implements OnInit {
  type = 'faq';
  previousUrl;
  contactVisible = false;
  privacyVisible = false;
  termsVisible = false;
  selectedoption;

  constructor(private route: Router) { }

  ngOnInit() {
    this.selectedoption = window.location.href.split('/').pop();
    // // console.log.log(this.selectedoption);
    this.checkType(this.selectedoption);
  }
  checkType(type) {
    this.type = type;
    // // console.log.log("testing...",this.route.url);
    // setTimeout(() => {
    const elems = document.querySelectorAll('.active');
    if (elems !== null) {
      for (let i = 0; i < elems.length; ++i) {
        if (_.contains(elems[i].classList, 'suppsubhead')) {
          elems[i].classList.remove('active');
        }
      }
    }
    // if (this.route.url === '/faq') {
      if (type === 'faq') {
        const faqTabValue = document.getElementById(type);
        faqTabValue.classList.add('active');
      } else if (type === 'contact-us') {
        this.contactVisible = true;
        const faqTabValue = document.getElementById(type);
        faqTabValue.classList.add('active');
      } else if (type === 'privacy-policy') {
        this.privacyVisible = true;
        const faqTabValue = document.getElementById(type);
        faqTabValue.classList.add('active');
      } else if (type === 'terms-of-service') {
        this.termsVisible = true;
        const faqTabValue = document.getElementById(type);
        faqTabValue.classList.add('active');
      }
    // }, 1000);
    // }
    this.route.events
    .pipe(filter((e: any) => e instanceof NavigationEnd),
        pairwise()
    ).subscribe((e: any) => {
      // // console.log.log('prev:', e);
      this.previousUrl = e[0].url;
      // // console.log.log('PreviousUrl:' + this.previousUrl);
    });
  }
}
